window.PLATFROM_CONFIG = {
    baseApi:'http://192.168.6.37:5849',
    wsApi: 'ws://192.168.0.1:8880',
  };
